import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Card, Link, Typography, Stack, Button, InputAdornment, TextField } from '@mui/material';
import Grid from '@mui/material/Grid'
import { useForm, Controller } from "react-hook-form";
import { showSuccess, showError } from '../../../utils/toast';
import { apiUrl } from '../../../utils/api';

// api

import { useGetStoreImgApiMutation } from '../../../redux/services/seller/sellerInfo';

const DataLogo = ({ name, path }) => {
    const url = `${apiUrl.shopPhoto}${path}`;
    console.log('logo', url);
    return (
        <img alt={name} src={url} style={{ height: "100%", width: "100%" }}
        />

    )
}

export const UpdateStoreImg = (props) => {
    const { open, onClose, sellerid, reloadData } = props;
    const [setUpdatePhoto, UpdatePhoto] = useGetStoreImgApiMutation()
    console.log("sellerId", sellerid?.id)


    const { register, handleSubmit, setValue, watch, control, reset, formState: { errors } } = useForm();

    const onUpdatePhoto = async (data, event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('id', sellerid?.id);
        formData.append('photo_1', data.photo_1);
        formData.append('photo_2', data.photo_2);
        formData.append('photo_3', data.photo_3);
        formData.append('req', "photos");

        console.log("photo_1", data.photo_1)
        console.log("photo_2", data.photo_2)
        console.log("photo_3", data.photo_3)





        try {
            await setUpdatePhoto(formData)

            onClose(null);
            reset()
            reloadData()

        }
        catch (error) {
            console.error("Error fetching data:", error);
            // showError('Error', error);

        }
    }

    useEffect(() => {
        if (UpdatePhoto.isSuccess) {
            showSuccess(`Photos Updated Successfully`)
            UpdatePhoto.reset()
        }
        if (UpdatePhoto.isError) {
            showError(UpdatePhoto.error.data.msg)
            UpdatePhoto.reset()
        }
    }, [UpdatePhoto])



    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
            >
                <DialogTitle id="alert-dialog-title" sx={{ textAlign: "center" }}>
                    <Typography variant='h4'> Update Shop Photo </Typography>
                    <hr />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {/* <Typography variant='h6'>{message?.current}</Typography> */}
                    </DialogContentText>
                    <br />
                    <br />

                    <form type="shopPhoto-form" onSubmit={handleSubmit(onUpdatePhoto)}>

                        <Grid container spacing={1} mb={2}>
                            <Grid item xs={12} sm={6} md={4} >

                                {/* <Controller
                                    name="photo_1" // Change this to the correct field name
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    <img
                                                        alt='img'
                                                        src="https://img.freepik.com/free-vector/illustration-cloud-upload_53876-35883.jpg?w=2000"
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                )}
                                            </div>
                                            <label htmlFor="file" className="footer">
                                                <p>Select</p>
                                                <input
                                                    // className='shop_Photo'
                                                    id="photo_1"
                                                    type="file"
                                                    name='photo_1'
                                                    {...register('photo_1')}
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                />
                                            </label>
                                        </div>
                                    )}
                                /> */}
                                <Controller
                                    name="photo_1"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    !sellerid?.photo_1 ? <img alt='img' src="https://img.freepik.com/free-vector/illustration-cloud-upload_53876-35883.jpg?w=2000" style={{ height: "100%", width: "100%" }} /> : <DataLogo path={sellerid?.photo_1} />

                                                )}
                                            </div>
                                            <label htmlFor="photo_1" className="footer">
                                                <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"><path d="M15.331 6H8.5v20h15V14.154h-8.169z" /><path d="M18.153 6h-.009v5.342H23.5v-.002z" /></g></svg>
                                                <p>Update Photo</p>

                                                <input
                                                    id='photo_1'
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                    style={{ display: 'none' }}

                                                />
                                            </label>
                                        </div>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>

                                {/* <Controller
                                    name="photo_2" // Change this to the correct field name
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    <img
                                                        alt='img'
                                                        src="https://img.freepik.com/free-vector/illustration-cloud-upload_53876-35883.jpg?w=2000"
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                )}
                                            </div>
                                            <label htmlFor="file" className="footer">
                                                <p>Select</p>
                                                <input
                                                    // className='shop_Photo'
                                                    id="photo_2"
                                                    type="file"
                                                    name="photo_2"
                                                    {...register('photo_2')}
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                />
                                            </label>
                                        </div>
                                    )}
                                /> */}
                                <Controller
                                    name="photo_2"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    !sellerid?.photo_2 ? <img alt='img' src="https://img.freepik.com/free-vector/illustration-cloud-upload_53876-35883.jpg?w=2000" style={{ height: "100%", width: "100%" }} /> : <DataLogo path={sellerid?.photo_2} />

                                                )}
                                            </div>
                                            <label htmlFor="photo_2" className="footer">
                                                <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"><path d="M15.331 6H8.5v20h15V14.154h-8.169z" /><path d="M18.153 6h-.009v5.342H23.5v-.002z" /></g></svg>
                                                <p>Update Photo</p>
                                                <input
                                                    id='photo_2'
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                    style={{ display: 'none' }}

                                                />
                                            </label>
                                        </div>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>

                                {/* <Controller
                                    name="photo_3" // Change this to the correct field name
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    <img
                                                        alt='img'
                                                        src="https://img.freepik.com/free-vector/illustration-cloud-upload_53876-35883.jpg?w=2000"
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                )}
                                            </div>
                                            <label htmlFor="file" className="footer">
                                                <p>Select</p>

                                                <input
                                                    // className='shop_Phot0'
                                                    id="photo_3"
                                                    type="file"
                                                    name='photo_3'
                                                    {...register('photo_3')}
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                />
                                            </label>
                                        </div>
                                    )}
                                /> */}
                                <Controller
                                    name="photo_3"
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    !sellerid?.photo_3 ? <img alt='img' src="https://img.freepik.com/free-vector/illustration-cloud-upload_53876-35883.jpg?w=2000" style={{ height: "100%", width: "100%" }} /> : <DataLogo path={sellerid?.photo_3} />

                                                )}
                                            </div>
                                            <label htmlFor="photo_3" className="footer">
                                                <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"><path d="M15.331 6H8.5v20h15V14.154h-8.169z" /><path d="M18.153 6h-.009v5.342H23.5v-.002z" /></g></svg>
                                                <p>Update Photo</p>

                                                <input
                                                    id='photo_3'
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                    style={{ display: 'none' }}
                                                />
                                            </label>
                                        </div>
                                    )}
                                />
                            </Grid>
                        </Grid>

                        <DialogActions>
                            <Button type="submit" >
                                Update
                            </Button>
                            <Button onClick={onClose}>Cancel</Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog >
        </>
    );
}



